import { Theme } from '@mui/material/styles';

/**
 * Shared base styles for all tooltip-like elements in the app.
 * Used by both the MuiTooltip theme override and canvas-based tooltip layers.
 */
export const getTooltipBaseStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.grey[900],
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  color: theme.palette.common.white,
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: '0.2px',
  padding: '8px 12px',
});
